import React, { useContext /* , useState  */ } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { /* useParams, */ Link } from 'react-router-dom';
import classNames from 'classnames';
import { CourseContext } from 'context/Context';
import useCourses from 'hooks/useCourses';
//import playIcon from 'assets/img/icons/play.svg';
import Flex from 'components/common/Flex';
//import Hoverbox from 'components/common/Hoverbox';
import SoftBadge from 'components/common/SoftBadge';
import StarRating from 'components/common/StarRating';
import course1 from 'assets/img/e-learning/courses/course1.png';
import beachVideo from 'assets/video/beach.mp4';
import beachPoster from 'assets/video/beach.jpg';
/* import OfferImage from './OfferImage'; */
import { currency } from 'helpers/utils';
import Avatar from 'components/common/Avatar';

const tags = {
 writing: {
  id: 1,
  type: 'primary',
  content: 'Writing',
  icon: 'pen-nib'
 },
 topTrainer: {
  id: 2,
  type: 'success',
  content: 'Top Trainer',
  icon: 'crown'
 },
 editorsChoice: {
  id: 3,
  type: 'warning',
  content: 'Editor’s Choice',
  icon: 'award'
 },
 misc: {
  id: 4,
  type: 'primary',
  content: 'Misc.',
  icon: 'thumbtack'
 },
 design: {
  id: 5,
  type: 'primary',
  content: 'Design',
  icon: 'brush'
 },
 bestSeller: {
  id: 6,
  type: 'success',
  content: 'Best Seller',
  icon: 'hashtag'
 },
 painting: {
  id: 7,
  type: 'primary',
  content: 'Painting',
  icon: 'palette'
 }
};
const course = {
 id: 'CN000001',
 name: 'Script Writing Masterclass: Introdution to Industry Cliches',
 price: 69.99,
 oldPrice: 139.99,
 excerpt:
  'Explore all the advanced design tools like Photoshop, Illustrator, Krita, Procreate, & Inkscape; trace the evolution of graphic design with us, from the first breakthrough of image development to today’s AI assisted designs. Begin your visual language journey with these advanced design tools.',
 trainer: 'Bill Finger',
 thumbnail: {
  image: course1,
  video: beachVideo,
  videoPoster: beachPoster
 },
 totalEnrolled: 92632,
 rating: 4.8,
 review: 78259,
 tags: [tags.writing, tags.topTrainer, tags.editorsChoice]
};
const Order = ({ product /* index */ }) => {
 //  const { company } = useParams();
 const { _id, image, receivers, status, amount, params } = product;

 /* const [showModal, setShowModal] = useState(false); */

 /*  const {
  thumbnail: { video, videoPoster },
  tags
 } = course; */

 const { isInFavouriteItems /* isInCart */ } = useContext(CourseContext);

 const { /* handleAddToCart */ handleFavouriteClick } = useCourses(course);
 return (
  <Card className="overflow-hidden">
   <Card.Body className="p-0">
    <Flex justifyContent="center" alignItems="center" wrap="wrap">
     <Avatar
      size="5xl"
      rounded="soft"
      src={image ?? params?.defaultValues?.project?.logo}
      name={params?.defaultValues?.project?.name}
      className="d-none d-lg-block"
     />
     <div className="p-x1 flex-grow-1">
      <Row className="g-0">
       <Col lg={7} as={Flex} className="flex-column pe-md-x1">
        <Flex justifyContent="end" alignItems="center" className="mb-2">
         <SoftBadge pill bg="primary">
          <FontAwesomeIcon icon="pen-nib" className="me-1" transform="shrink-4" />
          {status.toLowerCase()}
         </SoftBadge>
        </Flex>
        <Flex justifyContent="center" alignItems="center" wrap="nowrap">
         <Avatar
          size="3xl"
          src={image ?? params?.defaultValues?.project?.logo}
          name={params?.defaultValues?.project?.name}
          className="me-1 d-block d-sm-none"
         />
         <div className="flex-grow-1">
          <h5 className="mb-0 fs--1 fs-md-0 text-capitalize">
           <Link to={`/project/details/${params?.defaultValues?.project?._id}`}>
            {params?.defaultValues?.project?.name.toLowerCase()}
           </Link>
          </h5>
          <h4 className="m-0 fs--1 fs-md-0 fs-lg-1 text-capitalize">{receivers[0].arrayName.join(' ').toLowerCase()}</h4>
         </div>
        </Flex>

        <p className="fs--2 fs-md--1 text-end text-md-start">
         {params?.defaultValues?.terrains.map(e =>
          e.detail
           ? e.detail
           : `Lote ${e.num} ${e.blocks ? 'Mz ' + e.blocks : ''} - ${e.area} m2 ${e.stage ? '- Etapa ' + e.stage : ''}`
         )}
        </p>
        <div className="flex-1 d-flex align-items-end fw-semi-bold fs--2 fs-md--1">
         <span className="me-1 text-900">{3.5}</span>
         <StarRating readonly rating={3.5} />
         <span className="ms-2 text-secondary d-none d-sm-block">en comportamiento</span>
        </div>
       </Col>
       <Col lg={5} className="mt-2 mt-lg-0">
        <Flex justifyContent="between" className="h-100 rounded border-lg border-1 flex-lg-column p-lg-3">
         <div className="mb-lg-3 mt-auto mt-lg-0">
          <h4 className="m-0 fs-1 text-warning d-flex">
           <span className="fs-0 text-700">{currency(amount, true)}</span>
           {params?.saving > 0 && <del className="ms-1 fs--2 text-700">{params?.totals}</del>}
          </h4>
          <p className="mb-0 fs--2 fs-md--1 text-800">
           {params?.saving ? 'Ahorro de ' + currency(params?.saving, true) : 'Sin descuento'}
          </p>
         </div>
         <Flex className="mt-3 flex-lg-column gap-2">
          <Button
           size="sm"
           variant="falcon-default"
           className="fs--1 text-600 white-space-nowrap w-100"
           onClick={handleFavouriteClick}
          >
           <FontAwesomeIcon
            icon="file"
            className={classNames({
             'text-danger': isInFavouriteItems(_id)
            })}
           />
           <span className="ms-1 d-none d-lg-inline">Ver orden</span>
          </Button>
         </Flex>
        </Flex>
       </Col>
      </Row>
     </div>
    </Flex>
   </Card.Body>
  </Card>
 );
};

Order.propTypes = {
 product: PropTypes.shape({
  _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  image: PropTypes.string,
  receivers: PropTypes.array.isRequired,
  params: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired
  /* name: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired, */
  /* images: PropTypes.arrayOf(
   PropTypes.shape({
    image: PropTypes.string.isRequired,
    video: PropTypes.string.isRequired,
    videoPoster: PropTypes.string.isRequired
   })
  ).isRequired, */
  /* status: PropTypes.string.isRequired,
  financings: PropTypes.arrayOf(
   PropTypes.shape({
    minInitialPay: PropTypes.number.isRequired,
    maxFinancing: PropTypes.number.isRequired
   })
  ).isRequired,
  qualities: PropTypes.arrayOf(
   PropTypes.shape({
    value: PropTypes.string.isRequired
   })
  ).isRequired,
  shortDescription: PropTypes.string.isRequired,
  stock: PropTypes.number.isRequired */
 }).isRequired,
 index: PropTypes.number.isRequired
};

export default Order;
